import { useState, useEffect } from "react";
import { api } from "../../lib/api";

export const AboutManager = () => {
  const [aboutText, setAboutText] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [lastSaved, setLastSaved] = useState<string | null>(null);

  useEffect(() => {
    fetchAboutText();
  }, []);

  const fetchAboutText = async () => {
    try {
      const data = await api.getContentText("about", "main");
      if (data && data.content) {
        setAboutText(data.content);
        if (data.updated_at) setLastSaved(new Date(data.updated_at).toLocaleString());
      }
    } catch (error) {
      console.error("Error fetching about text:", error);
    }
  };

  const saveAboutText = async (content: string) => {
    setIsSaving(true);
    try {
      const data = await api.upsertContentText("about", "main", content);
      if (data && data.updated_at) {
        setLastSaved(new Date(data.updated_at).toLocaleString());
      }
    } catch (error) {
      console.error("Error saving about text:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold mb-4">Aboutセクション管理</h2>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-xl font-semibold mb-4">テキスト設定</h3>
        <div className="space-y-4">
          <textarea
            value={aboutText}
            onChange={(e) => setAboutText(e.target.value)}
            className="w-full h-32 p-2 border rounded resize-none"
            placeholder="例：イラストレーターのzooonです。&#13;&#10;季節を感じられる温かみのある作品作りを心がけています。&#13;&#10;お仕事のご依頼やご相談などお気軽にご連絡ください。"
          />
          <div className="flex justify-between items-center">
            <button
              onClick={() => saveAboutText(aboutText)}
              disabled={isSaving}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-blue-300"
            >
              {isSaving ? "保存中..." : "保存"}
            </button>
            {lastSaved && (
              <span className="text-sm text-gray-500">
                最終更新: {lastSaved}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
